import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/// todo adopt
/// http://localhost:8080/payments/index
/// http://localhost:8080/transactions/statements/parks all tabs 
const routes = [
    {
        path: '/(uk/|ru/)?/icons',
        name: 'allIcons',
        component: () => import('./views/allIcons'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'icons'
        },
    }, {
        path: '*',
        component: () => import('./views/NotFound'),
        query: true,
        meta: {
            requiresAuth: true,
            title: '404'
        }
    }, {
        path: '/(uk/|ru/)?/',
        component: () => import('./views/dashboard/Dashboard'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dashboard',
            title: 'dashboard'
        }
    }, {
        path: '/(uk/|ru/)?/dashboard',
        name: 'dashboard',
        component: () => import('./views/dashboard/Dashboard'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dashboard',
            title: 'dashboard'
        }
    }, {
        path: '/(uk/|ru/)?/login',
        name: 'login',
        component: () => import('./views/login/Login'),
        beforeEnter: (to, from, next) => {
            window.temphref =  window.temphref || location.pathname + location.search
            next();
        },
        meta: {
            title: 'Вход'
        }
    }, {
        path: '/(uk/|ru/)?/restore',
        name: 'restore',
        component: () => import('./views/login/Restore'),
        meta: {
            title: 'Восстановление пароля',
            requiresAuth: false,
        }
    }, {
        path: '',
        query: true,
        component: () => import('./views/drivers/Candidate/index'),
        //// adopt done
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Кандидаты'
        },
        children: [{
            path: '/(uk/|ru/)?/candidates/index',
            name: 'Candidate',
            query: true,
            component: () => import('./views/drivers/Candidate/modules/list'),
            //// adopt done
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-candidates',

                title: 'Кандидаты'
            },
        }, {
            path: '/(uk/|ru/)?/candidates/finished',
            name: 'CandidateListFinished',
            query: true,
            component: () => import('./views/drivers/Candidate/modules/finished'),
            //// adopt done
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-candidates',
                title: 'Кандидаты'
            },
        }]
    }, {
        path: '',
        name: 'payoutStatements',
        component: () => import('./views/payoutStatements/index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
            children: [{
                path: '/(uk/|ru/)?/payout-statements',
                name: 'PayoutStatementsSettings',
                component: () => import('./views/payoutStatements/tabs/settings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-autopark',
                    title: 'Настройки ведомостей'
                }
            }, {
                path: '',
                name: 'PayoutStatementsList',
                component: () => import('./views/payoutStatements/tabs/list'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-autopark',
                    title: 'Список ведомостей'
                },
                children: [{
                    path: '/(uk/|ru/)?/payout-list',
                    name: 'PayoutStatementsListActive',
                    component: () => import('./views/payoutStatements/tabs/active'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-autopark',
                        title: 'Активные'
                    },
                }, {
                    path: '/(uk/|ru/)?/payout-list/archive',
                    name: 'PayoutStatementsListArchive',
                    component: () => import('./views/payoutStatements/tabs/archive'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-autopark',
                        title: 'Архив'
                    },
                }]
            }]
    }, {
        path: '/(uk/|ru/)?/payout-statements/create',
        name: 'payoutStatementsCreate',
        component: () => import('./views/payoutStatements/form/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/edit',
        name: 'payoutStatementsEdit',
        component: () => import('./views/payoutStatements/form/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-create',
        name: 'PayoutStatementsListCreate',
        component: () => import('./views/payoutStatements/form/listEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit',
        name: 'PayoutStatementsListEdit',
        component: () => import('./views/payoutStatements/form/listEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit/item-view',
        name: 'PayoutStatementsListItemView',
        component: () => import('./views/payoutStatements/form/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit/item-create',
        name: 'PayoutStatementsListItemCreate',
        component: () => import('./views/payoutStatements/form/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/candidates/edit', 
        name: 'CandidateEdit',
        component: () => import('./views/drivers/Candidate/Edit'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Редактирвоание кандидата'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/candidates/view', 
        name: 'LeadView',
        component: () => import('./views/drivers/Candidate/LeadView'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Просмотр кандидата'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/default/create',
        name: 'DriverCreate',
        component: () => import('./views/drivers/default/DriverCreate'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Создание нового водителя'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/index', 
        name: 'DriversList',
        component: () => import('./views/drivers/default/List'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Водители'
        },
    }, {
        path: '/(uk/|ru/)?/offers/index', 
        name: 'offers',
        component: () => import('./views/drivers/oferts/index.vue'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Оферты'
        },
    }, {
        path: '/(uk/|ru/)?/orders/moderation-orders', 
        name: 'moderation-offers',
        component: () => import('./views/drivers/orders/moderationOrders'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Заказы на модерации'
            
        },
    }, {
        path: '/(uk/|ru/)?/work-rule/index', 
        name: 'Workrule',
        component: () => import('./views/drivers/workrule/WorkRule'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Условия работы'
        },
    }, {
        path: '/(uk/|ru/)?/orders/list', 
        name: 'Orders',
        component: () => import('./views/order/List'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Заказы'
            
        },
    }, {
        
        path: '/(uk/|ru/)?/cars/list', 
        name: 'CarsList',
        component: () => import('./views/drivers/default/CarsList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Автомобили'
            //// adopt done
        },
    }, {
        path: '', 
        component: () => import('./views/drivers/Block/Index'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Блокировка при смене водителя',
            altNavSubMenuActive: '/block-change-number/index',
        },
        children: [ {
            path: '/(uk/|ru/)?/block-change-number/index',
            name: 'BlockedNew',
            component: () => import('./views/drivers/Block/tables/new'),
            //// adopt done
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        }, {
            path: '/(uk/|ru/)?/block-change-number/verify',
            name: 'BlockedVerify',
            component: () => import('./views/drivers/Block/tables/verify'),
            //// adopt done
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        }, {
            path: '/(uk/|ru/)?/block-change-number/blocked',
            name: 'BlockedBlocked',
            component: () => import('./views/drivers/Block/tables/blocked'),
            //// adopt done
            query: true,
            props: true, 
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        },]
    }, {
        path: '',
        component: () => import('./views/drivers/default/DriverEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            altNavSubMenuActive:'/drivers/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/drivers/default/detail',
                name: 'DriverDetail',
                component: () => import('./views/drivers/default/modules/Detail'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/car',
                name: 'AutoDetail',
                component: () => import('./views/drivers/default/modules/Auto'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/transactions',
                name: 'TransactionsDetails',
                component: () => import('./views/drivers/default/modules/TransactionsDetails'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            },  {
                path: '/(uk/|ru/)?/drivers/default/detail/changed-details',
                name: 'ParkOrdersChangedDetails',
                component: () => import('./views/drivers/default/modules/ParkOrdersChangedDetails'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, 
            // {
            //     //http://localhost:8080/drivers/default/detail/monitoring?driver_id=fcb0563cdafdaef3d26275731c8c83cf&park_id=2
            //     path: '/(uk/|ru/)?/drivers/default/detail/monitoring',
            //     name: 'MonitoringIncomePayment',
            //     component: () => import('./views/drivers/default/modules/Monitoring'),
            //     //TODO: remove
            //     query: true,
            //     meta: {
            //         requiresAuth: true,
            //         activeSideIcon:'#icon-drive',
            //         title: 'Редактирование водителя'
            //     },
            // }, 
            {
                path: '/(uk/|ru/)?/drivers/default/detail/bonus-details',
                name: 'BonusDetails',
                component: () => import('./views/drivers/default/modules/BonusDetails'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/balance-history',
                name: 'BalanceHistory',
                component: () => import('./views/drivers/default/modules/BalanceHistory'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/promo-raffle',
                name: 'PromoRaffle',
                component: () => import('./views/drivers/default/modules/PromoRaffle'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Купоны розыгрыша'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/payments',
                name: 'PaymentsList',
                component: () => import('./views/drivers/default/modules/PaymentsList'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/account',
                name: 'AccountControl',
                component: () => import('./views/drivers/default/modules/AccountControl'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/cards',
                name: 'DriverCardControl',
                component: () => import('./views/drivers/default/modules/DriverCardControl'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/history',
                name: 'History',
                component: () => import('./views/drivers/default/modules/History'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/order',
                name: 'Order',
                component: () => import('./views/drivers/default/modules/Order'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/HoldOrders',
                name: 'HoldOrders',
                component: () => import('./views/drivers/default/modules/HoldOrders'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/statement',
                name: 'Statement',
                component: () => import('./views/drivers/default/modules/Statement'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/AutoPay',
                name: 'AutoPay',
                component: () => import('./views/drivers/default/modules/AutopayTable'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/topup',
                name: 'TopUp',
                component: () => import('./views/drivers/default/modules/TopUp'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '',
                name: 'PromoCodeTabs',
                component: () => import('./views/drivers/default/modules/PromoCodeTabs'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
                children: [
                    {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo/active',
                        name: 'PromoCode',
                        component: () => import('./views/drivers/default/modules/PromoCode'),
                        //// adopt done
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }, {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo/new',
                        name: 'PromoCodeNew',
                        component: () => import('./views/drivers/default/modules/PromoCodeNew'),
                        //// adopt done
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }
                ]
            }, {
                path: '',
                name: 'PromoActiveList',
                component: () => import('./views/drivers/default/modules/PromoInfo'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
                children: [
                    {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo',
                        name: 'PromoInfo',
                        component: () => import('./views/drivers/default/modules/PromoActiveList'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }
                ]
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/referral',
                name: 'Referral',
                component: () => import('./views/drivers/default/modules/Referral'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/referral-program',
                name: 'ReferralProgram',
                component: () => import('./views/drivers/default/modules/ReferralProgram'),
                //// adopt done
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/log-payment',
                name: 'LogPayment',
                component: () => import('./views/drivers/default/modules/LogPayment'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/call-history',
                name: 'CallHistory',
                component: () => import('./views/drivers/default/modules/Callhistory'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/payout',
                name: 'PayoutList',
                component: () => import('./views/drivers/default/modules/PayoutList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, { 
                path: '/(uk/|ru/)?/drivers/default/detail/documents',
                name: 'Documents',
                component: () => import('./views/drivers/default/modules/Documents'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Документы'
                },
            }
        ]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment', 
        redirect:'/(uk/|ru/)?/dashboard/company-manangment/park',
        name: 'Company',
        component: () => import('./views/cabinet/company/Company'),
        query: true,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/company-manangment/park',
                name: 'CompanyPark',
                component: () => import('./views/cabinet/company/tabs/CompanyPark'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/role',
                name: 'CompanyRole',
                component: () => import('./views/cabinet/company/tabs/CompanyRole'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/user',
                name: 'CompanyUser',
                component: () => import('./views/cabinet/company/tabs/CompanyUser'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/department',
                name: 'CompanyDepartment',
                component: () => import('./views/cabinet/company/tabs/CompanyDepartment'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/provider',
                name: 'CompanyPaymentProvider',
                component: () => import('./views/cabinet/company/tabs/CompanyPaymentProvider'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/source-payment-provider',
                name: 'CompanySourcePaymentProvider',
                component: () => import('./views/cabinet/company/tabs/CompanySourcePaymentProvider'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/payment-config-and-commission',
                name: 'CompanyPaymentConfigAndCommission',
                component: () => import('./views/cabinet/company/tabs/CompanyPaymentConfigAndCommission'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/provider-service',
                name: 'CompanyProviderService',
                component: () => import('./views/cabinet/company/tabs/CompanyProviderService'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/chat-platform', 
                name: 'CompanyChatPlatform',
                component: () => import('./views/cabinet/company/tabs/CompanyChatPlatform'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/application-instance', 
                name: 'CompanyApplicationInstance',
                component: () => import('./views/cabinet/company/tabs/CompanyApplicationInstance'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting', 
                //name: 'CompanyApplicationManagement',
                component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
                children: [{
                    path: '', 
                    //name: 'CompanyApplicationManagementGeneral',
                    name: 'CompanyApplicationManagement',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/General.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/revision', 
                    name: 'CompanyApplicationManagementRevision',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/Revision.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                    
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/revision/form', 
                    name: 'CompanyApplicationManagementRevisionForm',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/RevisionForm.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    }, 
                    
                },  {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta', 
                    name: 'CompanyApplicationManagementRevisionOfertaList',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/OfertaList.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },    
                },  {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/aboutus', 
                    name: 'CompanyApplicationManagementAboutus',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/aboutus.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },    
                },{
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta/edit/:id', 
                    name: 'CompanyApplicationManagementRevisionOferta',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/Oferta.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },    
                },{
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta/create', 
                    name: 'CompanyApplicationManagementRevisionOfertaCreate',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/Oferta.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },    
                },  {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/translate', 
                    name: 'CompanyApplicationManagementRevisionTranslate',
                    component: () => import('./views/cabinet/company/tabs/CompanyApplicationManagement/Translate.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },    
                }]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings', 
                component: () => import('./views/cabinet/company/tabs/CompanyTeamSetting'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настройка Бригад'
                },
                children: [{
                    path: '', 
                    name: 'CompanyTeamSettingworkRule',
                    component: () => import('./views/cabinet/company/tabs/CompanyTeamSetting/WorkRule.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Условия работы Бригад'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings/settings', 
                    name: 'CompanyTeamSetting',
                    component: () => import('./views/cabinet/company/tabs/CompanyTeamSetting/Settings.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка Бригад'
                    },
                },]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/overdraft', 
                name: 'CompanyOverdraft',
                component: () => import('./views/cabinet/company/tabs/CompanyOverdraft'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Офердрафт'
                },
              
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/spands', 
                name: 'CompanySpends',
                component: () => import('./views/cabinet/company/tabs/CompanySpends'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/ie',
                component: () => import('./views/cabinet/company/tabs/CompanyIe'),
                // TODO: Adopt!
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настройки ИП'
                },
                children: [{
                    path: '', 
                    name: 'CompanyIe',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/Main.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, основные'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/output-blocking', 
                    name: 'CompanyIeOutputBlocking',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/OutputBlocking.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex', 
                    name: 'CompanyIeSigex',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/Sigex.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/Sapar', 
                    name: 'CompanyIeSapar',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/Sapar.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/payda', 
                    name: 'CompanyIePayda',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/Payda.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                },{
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/contract', 
                    name: 'CompanyIeContract',
                    component: () => import('./views/cabinet/company/tabs/CompanyIe/CompanyIeContract.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Контракты'
                    },
                },]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/settings',
                name: 'CompanyOtherSettings',
                component: () => import('./views/cabinet/company/tabs/OtherSettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Прочее'
                },
            },  {
                path: '/(uk/|ru/)?/dashboard/company-manangment/contracts',
                name: 'CompanyContractorsPayoutParks',
                component: () => import('./views/cabinet/company/tabs/CompanyContractorsPayoutParks'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Прочее'
                },  
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/referral-settings',
                name: 'CompanyReferralSettings',
                component: () => import('./views/cabinet/company/tabs/CompanyReferralSettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/wolt-agreement',
                name: 'CompanyWoltCooperationAgreement',
                component: () => import('./views/cabinet/company/tabs/CompanyWoltCooperationAgreement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                }, 
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/telephony',
                name: 'CompanyTelephonySettings',
                component: () => import('./views/cabinet/company/tabs/CompanyTelephonySettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/iron-park-agreement',
                name: 'CompanyIronParkAgreement',
                component: () => import('./views/cabinet/company/tabs/IronParkAgreement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Договор аренды'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/ai',
                name: 'CompanyAISettings',
                component: () => import('./views/cabinet/company/tabs/CompanyAISettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настройки ИИ'
                },
                children: [{
                        path: '', 
                        name: 'CompanyAISettings',
                        component: () => import('./views/cabinet/company/tabs/aisettings/index.vue'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Настройки ИИ, основные'
                        },
                    },{
                        path: '/(uk/|ru/)?/dashboard/company-manangment/ai/promo',
                        name: 'CompanyAISettingsPromo',
                        component: () => import('./views/cabinet/company/tabs/aisettings/promo.vue'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Настройки ИИ, промо'
                        },
                    },{
                        path: '/(uk/|ru/)?/dashboard/company-manangment/ai/parks',
                        name: 'CompanyAISettingsParks',
                        component: () => import('./views/cabinet/company/tabs/aisettings/parks.vue'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Настройки ИИ, парки'
                        },
                    },
                ]
            },]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex/form', 
        name: 'SigexForm',
        component: () => import('./views/cabinet/company/tabs/CompanyIe/SigexForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Sigex форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex/form', 
        name: 'SaparForm',
        component: () => import('./views/cabinet/company/tabs/CompanyIe/SaparForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки Sapar форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/payda/form', 
        name: 'PaydaForm',
        component: () => import('./views/cabinet/company/tabs/CompanyIe/PaydaForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Payda форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/contract/edit', 
        name: 'ContractForm',
        component: () => import('./views/cabinet/company/tabs/CompanyIe/ContractForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Контракты'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings/edit', 
        name: 'FormTeamSetting',
        component: () => import('./views/cabinet/company/form/TeamSetting'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/overdraft', 
        name: 'Overdraft',
        component: () => import('./views/overdraft/Overdraft'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Овердрафт'
        },
        children: [{
            path: '', 
            name: 'overdraft-new',
            component: () => import('./views/overdraft/tables/new'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/active', 
            name: 'overdraft-active',
            component: () => import('./views/overdraft/tables/active'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/rejected', 
            name: 'overdraft-rejected',
            component: () => import('./views/overdraft/tables/rejected'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        },  {
            path: '/(uk/|ru/)?/overdraft/closed', 
            name: 'overdraft-closed',
            component: () => import('./views/overdraft/tables/closed'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        },  {
            path: '/(uk/|ru/)?/overdraft/suspended', 
            name: 'overdraft-suspended',
            component: () => import('./views/overdraft/tables/suspended'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/park/edit', 
        name: 'CompanyParkEdit',
        component: () => import('./views/cabinet/company/form/Park'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Парк'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/role/edit', 
        name: 'CompanyRoleEdit',
        // adopt done
        component: () => import('./views/cabinet/company/form/Role'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/user/edit', 
        name: 'CompanyUserEdit',
        component: () => import('./views/cabinet/company/form/User'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    },{
        path: '/(uk/|ru/)?/dashboard/company-manangment/telephony/settings', 
        name: 'CompanyUserTelephonySettings',
        component: () => import('./views/cabinet/company/form/TelephonySettings'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ai/add-parks', 
        name: 'aiParksAdd',
        component: () => import('./views/cabinet/company/tabs/aisettings/addParks.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Добавление парка'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/telephony/settings/edit', 
        name: 'TelephonyRuleAdd',
        component: () => import('./views/cabinet/company/form/TelephonyRuleAdd'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/provider-service/edit',
        name: 'ServiceProviderEdit',
        component: () => import('./views/cabinet/company/form/ServiceProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/department/edit', 
        name: 'CompanyDepartmentEdit',
        component: () => import('./views/cabinet/company/form/Department'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/provider/edit',
        name: 'PaymentProvider',
        component: () => import('./views/cabinet/company/form/PaymentProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/source-payment-provider/edit', 
        name: 'SourcePaymentProvider',
        // adopt done
        component: () => import('./views/cabinet/company/form/SourcePaymentProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/chat-platform/edit', 
        name: 'ChatPlatform',
        component: () => import('./views/cabinet/company/form/ChatPlatform'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/application-instance/edit', 
        name: 'ApplicationInstanceform',
        component: () => import('./views/cabinet/company/form/ApplicationInstanceform'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet', 
        name: 'Personal',
        component: () => import('./views/cabinet/personal/Personal'),
        //// adopt done 
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Персональный кабинет'
        },
    }, {
        path: '', 
        name: 'CallCenter',
        component: () => import('./views/cabinet/callcenter/CallCenter'),
        //// adopt done 
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление кол центром'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger',
                name: 'PhrazeCategoriesList',
                component: () => import('./views/cabinet/callcenter/tabs/PhrazeCategoriesList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром'
                },
            },  {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/phraze',
                name: 'PhrazeCategoriesPhrazeList',
                component: () => import('./views/cabinet/callcenter/tabs/PhrazeCategoriesPhrazeList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром - фразы'
                },
            },{
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/statistic',
                name: 'StatisticList',
                component: () => import('./views/cabinet/callcenter/tabs/StatisticList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром'
                },
            }, 
        ]
    }, {
        path: '', 
        name: 'CabinetReports',
        component: () => import('./views/cabinet/reports/Main'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Отчеты'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports',
                name: 'CabinetReportsDriverList',
                component: () => import('./views/cabinet/reports/tabs/Drivers'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Водители'
                },
            },{
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/detail',
                name: 'CabinetReportsDetail',
                component: () => import('./views/cabinet/reports/tabs/Detail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: детальнее водители'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats',
                // name: 'CabinetReportsChats',
                component: () => import('./views/cabinet/reports/tabs/Chats'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: чаты'
                },
                children: [
                    {
                        path: '',
                        name: 'ChatsGeneral',
                        component: () => import('./views/cabinet/reports/tabs/chats/ChatsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Общее'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/category',
                        name: 'ChatsCategory',
                        component: () => import('./views/cabinet/reports/tabs/chats/ChatsCategory'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Категории'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/department',
                        name: 'ChatsDepartment',
                        component: () => import('./views/cabinet/reports/tabs/chats/ChatsDepartment'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Департаменты'
                        },
                    }  
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/detail',
                name: 'CabinetReportsChatsDetail',
                component: () => import('./views/cabinet/reports/tabs/chats/ChatsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: чаты'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds',
                // name: 'CabinetReportsLeeds',
                component: () => import('./views/cabinet/reports/tabs/Leeds'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды'
                },
                children: [
                    {
                        path: '',
                        name: 'LeedsGeneral',
                        component: () => import('./views/cabinet/reports/tabs/leeds/LeedsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Лиды'
                        },
                    },  {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/source',
                        name: 'LeedsSource',
                        component: () => import('./views/cabinet/reports/tabs/leeds/LeedsSource'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Лиды Источники'
                        },
                    },
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/detail',
                name: 'CabinetReportsLeedsDetail',
                component: () => import('./views/cabinet/reports/tabs/leeds/LeedsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/source/detail',
                name: 'CabinetReportsLeedsSourceDetail',
                component: () => import('./views/cabinet/reports/tabs/leeds/LeedsSourceDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls',
                // name: 'CabinetReportsCalls',
                component: () => import('./views/cabinet/reports/tabs/Calls'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Звонки'
                },
                children: [
                    {
                        path: '',
                        name: 'CallsGeneral',
                        component: () => import('./views/cabinet/reports/tabs/calls/CallsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/departments',
                        name: 'Callsdepartments',
                        component: () => import('./views/cabinet/reports/tabs/calls/CallsDepartments'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/category',
                        name: 'CallsCategory',
                        component: () => import('./views/cabinet/reports/tabs/calls/CallsCategory'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/statistic',
                        name: 'CallsStatistic',
                        component: () => import('./views/cabinet/reports/tabs/calls/CallsStatistic'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    },
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/detail',
                name: 'CabinetReportsCallsDetail',
                component: () => import('./views/cabinet/reports/tabs/calls/CallsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Звонки Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/logs',
                name: 'CabinetReportsLogs',
                component: () => import('./views/cabinet/reports/tabs/Logs'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
            },  {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/apps',
                name: 'CabinetReportsApp',
                component: () => import('./views/cabinet/reports/tabs/apps'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
            },  {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/ai',
                //name: 'CabinetReportsAI',
                component: () => import('./views/cabinet/reports/tabs/ai'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
                children: [
                    {
                        path: '',
                        name: 'botStatisticWorks',
                        component: () => import('./views/cabinet/reports/tabs/ai/botStatisticWorks'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Статистика по работе бота'
                        },
                    },  {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/ai/candidates-regions',
                        name: 'botCandidatesRegions',
                        component: () => import('./views/cabinet/reports/tabs/ai/botCandidatesRegions'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Статистика по регистрациям бота'
                        },
                    },
                ]
            }
        ]
    }, {
        path: '', 
        name: 'CabinetPayments',
        component: () => import('./views/cabinet/payments/System'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/payments',
                name: 'CabinetPaymentsList',
                component: () => import('./views/cabinet/payments/tabs/List'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            },  {
                path: '/(uk/|ru/)?/dashboard/cabinet/payments/cards',
                name: 'CabinetPaymentsCardList',
                component: () => import('./views/cabinet/payments/tabs/CabinetPaymentsCardList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/summary-reports',
        name: 'SummarReportsDetail',
        component: () => import('./views/cabinet/summary/index.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Отчеты: Водители'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/payments/create', 
        name: 'PaymentCreate',
        component: () => import('./views/cabinet/payments/tabs/PaymentCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/payments/cards/create', 
        name: 'PaymentCardsCreate',
        // adopt done
        component: () => import('./views/cabinet/payments/tabs/PaymentCardsCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/fast-Phraze',
        name: 'AddFastPhraze',
        // adopt done
        component: () => import('./views/cabinet/callcenter/tabs/AddFastPhraze'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Новая быстрая фраза'
        },
    }, {
        path: '/(uk/|ru/)?/payments/index',
        name: 'bill',
        query: true,
        component: () => import('./views/payments/bill'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'История вывода средств'
        },
        children: [
            // {
            //     path: '',
            //     name: 'bill-active',
            //     component: () => import('./views/payments/modules/billActive'),
            //     query: true,
            //     meta: {
            //         requiresAuth: true,
            //         title: 'Вывод средств'
            //     },
            // },  
            {
                // path: '/(uk/|ru/)?/payments/archive',
                path: '',
                name: 'bill-archive',
                component: () => import('./views/payments/modules/billArchive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            },
        ]

    }, {
        path: '',
        name: 'TerminalReportMain',
        query: true,
        component: () => import('./views/terminals/Report'),
        //TODO: adopt!
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Отчетность терминалов'
        },
        children:[{
            path: '/(uk/|ru/)?/terminals/report',
            name: 'TerminalReport',
            query: true,
            component: () => import('./views/terminals/tabs/success'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов'
            },
        }, {
            path: '/(uk/|ru/)?/terminals/report/error',
            name: 'TerminalReportError',
            query: true,
            component: () => import('./views/terminals/tabs/errors'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов ошибки'
            },
        }, {
            path: '/(uk/|ru/)?/terminals/report/qr',
            name: 'TerminalReportQR',
            query: true,
            component: () => import('./views/terminals/tabs/qr'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов ошибки'
            },
        }]
    }, {
        path: '/(uk/|ru/)?/terminals/config',
        name: 'TerminalSettings',
        query: true,
        component: () => import('./views/terminals/Config'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Настройка терминалов'
        },
    }, {
        path: '/(uk/|ru/)?/terminals/create',
        name: 'TerminalCreate',
        query: true,
        component: () => import('./views/terminals/Create'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Управление терминалами'
        },
    }, {
        path: '',
        name: 'PayCardsCreate',
        component: () => import('./views/cards/PayCards'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Карты для Выплат',
            altNavSubMenuActive:'/cards/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/cards/index',
                name: 'PayCards',
                component: () => import('./views/cards/modules/Cards'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Карты'
                },
            }, {
                path: '/(uk/|ru/)?/cards/index/top',
                name: 'PayCardsTop',
                component: () => import('./views/cards/modules/TopCards'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Топ карт'
                },
            }, {
                path: '/(uk/|ru/)?/cards/exeption',
                name: 'PayCardsExeption',
                component: () => import('./views/cards/modules/Except'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Исключения мошеннических карт'
                },
            },
        ]
    }, 
    {
        path: '/(uk/|ru/)?/cards/detail',
        name: 'Details',
        component: () => import('./views/cards/Details'),
        query: true, 
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Дитализация'
        },
    }, 
    {
        path: '/(uk/|ru/)?/fraudulent/index',
        name: 'Fraudulent',
        component: () => import('./views/cards/Fraudulent'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Мошеннические карты'
        },
    }, {
        path: '/(uk/|ru/)?/queue/index',
        name: 'QueuePayments',
        component: () => import('./views/payments/QueuePayments'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Очередь платежей'
        },
    }, {
        path: '/(uk/|ru/)?/hold-funds/index',
        component: () => import('./views/payments/HoldFunds'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Очередь платежей'
        },
        children: [
            {
                path: '',
                name: 'QueuePaymentsActive', // Имя дочернего маршрута по умолчанию
                component: () => import('./views/payments/modules/hfActive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-bill',
                    title: 'Заморозка средств'
                },
            }, {
                path: '/(uk/|ru/)?/hold-funds/inactive',
                name: 'QueuePaymentsinActive',
                component: () => import('./views/payments/modules/hfInActive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-bill',
                    title: 'Очередь платежей'
                },
            }
        ]
    }, {
        path: '/(uk/|ru/)?/provider/index',
        component: () => import('./views/payments/Provider'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Движение средств по счетам провайдеров'
        },
    }, {
        path: '/(uk/|ru/)?/payments/log-error-payments',
        component: () => import('./views/payments/Error'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Отчет ошибок платежей'
        },
    }, {
        path: '/(uk/|ru/)?/scheduled/list',
        component: () => import('./views/payments/Scheduled'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Запланированные платежи'
        },
    }, {
        path: '/(uk/|ru/)?/transactions/index',
        name: 'Transactions',
        component: () => import('./views/transactions/Transactions'),
        // do adopt
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ручные транзакции'
        },
    }, {
        path: '/(uk/|ru/)?/transactions/mass',
        name: 'Mass',
        component: () => import('./views/transactions/Mass'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Массовые транзакции'
        },
    }, {
        path: '/(uk/|ru/)?/transactions/mass/detail',
        redirect: '/(uk/|ru/)?/transactions/mass/detail/info',
        name: 'FormMass',
        component: () => import('./views/transactions/form/FormMass'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
        },
        children: [
            {
                path: '/(uk/|ru/)?/transactions/mass/detail/info',
                name: 'MainInfo',
                component: () => import('./views/transactions/form/MainInfo'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Новая массовая транзакция'
                },
            },  {
                path: '/(uk/|ru/)?/transactions/mass/detail/import',
                name: 'Import',
                component: () => import('./views/transactions/form/Import'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Новая массовая транзакция'
                },
            },  {
                path: '/(uk/|ru/)?/transactions/mass/detail/drivers',
                name: 'Drivers',
                component: () => import('./views/transactions/form/Drivers'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Редактирование массовой транзакции'
                },
            }
        ]
    }, {
        path: '',
        component: () => import('./views/transactions/Statements'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ведомость',
            altNavSubMenuActive:'/transactions/statements',
        }, 
        children: [
            {
                path: '/(uk/|ru/)?/transactions/statements',
                name: 'StatementsCommon',
                component: () => import('./views/transactions/tables/Common'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/statements/parks',
                name: 'StatementsParks',
                component: () => import('./views/transactions/tables/Parks'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/income',
                name: 'Income',
                component: () => import('./views/transactions/Income'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Отчеты'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/drivers',
                name: 'StatementsDrivers',
                component: () => import('./views/transactions/tables/Drivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            }, 
        ]
    }, {
        path: '/(uk/|ru/)?/banner/index',
        name: 'BannerTable',
        // adopt done
        component: () => import('./views/banner/BannerTable'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Баннера'
        },
    }, {
        path: '/(uk/|ru/)?/banner/detail',
        name: 'BannerCreate',
        // adopt done
        component: () => import('./views/banner/BannerCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Создание нового банера'
        },
    }, {
        path: '',
        component: () => import('./views/antifraud/AntifraudList'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Антифрод',
            altNavSubMenuActive: '/anti-fraud/index'
        },
        children: [
            {
                path: '/(uk/|ru/)?/anti-fraud/index',
                name: 'new',
                component: () => import('./views/antifraud/tables/new'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/verify',
                name: 'verify',
                component: () => import('./views/antifraud/tables/verify'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод',
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/blocked',
                name: 'blocked',
                component: () => import('./views/antifraud/tables/blocked'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/black-list',
                name: 'BlackList',
                component: () => import('./views/antifraud/tables/BlackList'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/exeption-drivers',
                name: 'ExiptionDrivers',
                component: () => import('./views/antifraud/tables/ExiptionDrivers'),
                // adopt done
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/payout/anti-fraud-orders',
                name: 'antifraudorders',
                component: () => import('./views/antifraud/tables/Antifraudorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Сводный отчет проблемных заказов'
                },
            }, {
                path: '/(uk/|ru/)?/payout/held-orders',
                name: 'heldorders',
                component: () => import('./views/antifraud/tables/Heldorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Удержанные заказы',
                    type: 'opened'
                },
            }, {
                path: '/(uk/|ru/)?/payout/held-orders/closed',
                name: 'heldordersclosed',
                component: () => import('./views/antifraud/tables/Heldorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Удержанные заказы',
                    type: 'closed'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/anti-fraud/security',
        component: () => import('./views/antifraud/Security'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Антифрод Глобальная настройка'
        }
    }, {
        path: '/(uk/|ru/)?/anti-fraud/devices',
        component: () => import('./views/antifraud/Device'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Идентификаторы устройств'
        }
    }, {
        path: '/(uk/|ru/)?/promotions/index',
        component: () => import('./views/promotions/Index'),
        name: 'PromotionsList',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Акции'
        },
    }, {
        path: '/(uk/|ru/)?/promotions/commission-free',
        component: () => import('./views/promotions/commissionFree/index'),
        name: 'CommissionFree',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Настройка акционных периодов'
        },
    },  {
        path: '/(uk/|ru/)?/promotions/commission-free/edit',
        component: () => import('./views/promotions/commissionFree/edit'),
        name: 'CommissionFreeEdit',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Настройка акционных периодов'
        },
    }, {
        path: '',
        component: () => import('./views/promotions/Edit'),
        // adopt done
        //name: 'PromotionEdit',
        altNavSubMenuActive:'/promotions/index',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
        },
        children: [
            {
                path: '/(uk/|ru/)?/promotions/edit',
                name: 'PromotionEditMain',
                component: () => import('./views/promotions/modules/Main'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/work-rules',
                name: 'PromotionWorkRules',
                component: () => import('./views/promotions/modules/WorkRules'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/raffle-coupon',
                name: 'PromotionRaffleCoupon',
                component: () => import('./views/promotions/modules/RaffleCoupon'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/raffle-ddriver',
                name: 'PromotionRaffleDriver',
                component: () => import('./views/promotions/modules/RaffleDriver'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/reports/transactions',
                name: 'PromotionCompensationTransaction',
                component: () => import('./views/promotions/modules/Transactions'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/reports/drivers',
                name: 'PromotionCompensationDrivers',
                component: () => import('./views/promotions/modules/PromotionCompensationDrivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/pay-history',
                name: 'PromotionPayHistory',
                component: () => import('./views/promotions/modules/PromotionPayHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/participate-history',
                name: 'PromotionParticipateHistory',
                component: () => import('./views/promotions/modules/PromotionParticipateHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/import',
                name: 'PromotionAddDrivers',
                component: () => import('./views/promotions/modules/PromotionAddDrivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers',
                name: 'PromotionDriver',
                component: () => import('./views/promotions/modules/Driver'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, 
        ]
    }, {
        path: '/(uk/|ru/)?/push-notification/list',
        name: 'PushList',
        component: () => import('./views/push/List.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Рассылки уведомлений'
        },
    }, {
        path: '/(uk/|ru/)?/push-notification/create',
        name: 'PushCreate',
        component: () => import('./views/push/Create.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Создать рассылку',
            altNavSubMenuActive:'/push-notification/list',
        },
    }, {
        path: '/(uk/|ru/)?/promocodes/index',
        name: 'Promocodes',
        component: () => import('./views/promocodes/Promo'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '/(uk/|ru/)?/polls/index',
        name: 'polls',
        component: () => import('./views/polls/index'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    }, {
        path: '/(uk/|ru/)?/transactions/bonus',
        name: 'TransactionsBonus',
        component: () => import('./views/transactions/bonus'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Список бонусов'
        }
    }, {
        path: '/(uk/|ru/)?/polls/view',
        name: 'pollsview',
        component: () => import('./views/polls/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    }, {
        path: '/(uk/|ru/)?/polls/edit',
        name: 'PollEdit',
        component: () => import('./views/polls/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    },
    {
        path: '',
        component: () => import('./views/payout/list'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ведомости выплат',
            altNavSubMenuActive: '/payout/list',
        }, 
        children: [
            {
                path: '/(uk/|ru/)?/payout',
                name: 'PayoutStatements',
                component: () => import('./views/payout/tables/Statements'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомости'
                },
            },
            {
                path: '/(uk/|ru/)?/payout/list',
                name: 'PayoutCommon',
                component: () => import('./views/payout/tables/Common'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Транзакции'
                },
            }, {
                path: '',
                component: () => import('./views/payout/Problems'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомости выплат проблемные'
                },
                children: [{
                    path: '/(uk/|ru/)?/payout/problems',
                    name: 'PayoutStatementsProblems',
                    component: () => import('./views/payout/tables/ProblemParkDriver'),
                    query: true,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-transaction',
                        title: 'Ведомости выплат проблемные'
                    },
                }, {
                    path: '/(uk/|ru/)?/payout/problems/ie',
                    name: 'PayoutStatementsProblemsIe',
                    component: () => import('./views/payout/tables/ProblemParkDriverIe'),
                    query: true,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-transaction',
                        title: 'Ведомости выплат проблемные'
                    },
                }]
            },  {
                path: '/(uk/|ru/)?/payout/unpaid-orders',
                name: 'SummaryUnpaidOrders',
                component: () => import('./views/payout/tables/UnpaidOrders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: ' Сводный отчет проблемных заказов'
                },
            },  
        ]
    }, {
        path: '/(uk/|ru/)?/payout/problems/detail',
        name: 'PayoutStatementsProblemsDetail',
        component: () => import('./views/payout/detail'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Детализация заказа'
        }, 
    },
    // {
    //     path: '/(uk/|ru/)?/sms-conversion/index',
    //     name: 'smsList',
    //     component: () => import('./views/conversion/Smslist'),
    //     query: true,
    //     meta: {
    //         requiresAuth: true,
    //         activeSideIcon:'#icon-discount',
    //         title: 'Сопровождение конверсии'
    //     }
    // },
    {
        path: '/(uk/|ru/)?/sms-conversio/create',
        name: 'SmsCreate',
        component: () => import('./views/conversion/SmsCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-конверсия',
            altNavSubMenuActive:'/sms-conversion-event/index',
        }
    }, {
        path: '/(uk/|ru/)?/sms-conversion-event/index',
        name: 'EventsList',
        component: () => import('./views/conversion/EventsList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-события',
            altNavSubMenuActive:'/sms-conversion-event/index',
        }
    }, {
        path: '/(uk/|ru/)?/sms-conversion/events/edit',
        name: 'EventEdit',
        component: () => import('./views/conversion/EventEdit'),
        // adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-события'
        }
    }, {
        path: '/(uk/|ru/)?/promocodes/detail', 
        name: 'PromocodeDetaild',
        component: () => import('./views/promocodes/Detail'),
         //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '/(uk/|ru/)?/promocodes/edit',
        name: 'PromocodesEdit',
        component: () => import('./views/promocodes/Edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '/(uk/|ru/)?/baiga/index',
        component: () => import('./views/baiga/Index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
        },
        children: [
            {
                path: '',
                name: 'BaigaSettings',
                component: () => import('./views/baiga/Settings'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            }, {
                path: '/(uk/|ru/)?/baiga/Results',
                name: 'BaigaResults',
                component: () => import('./views/baiga/Results'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            }, {
                path: '/(uk/|ru/)?/baiga/publish',
                name: 'BaigaPublish',
                component: () => import('./views/baiga/Publish'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            }, 
        ]
    }, {
        path: '/(uk/|ru/)?/baiga/edit',
        name: 'SettingsForm',
        component: () => import('./views/baiga/SettingsForm'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Байга'
        }
    }, {
        path: '',
        component: () => import('./views/teams/Teams'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Список бригад',
            altNavSubMenuActive:'/teams/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/teams/index',
                name: 'TeamsList', // Имя дочернего маршрута по умолчанию
                component: () => import('./views/teams/tables/TeamList'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/top',
                name: 'TeamTop',
                component: () => import('./views/teams/tables/TeamTop'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title: 'Бригады',
                },
            }
        ]
    }, {
        path: '/(uk/|ru/)?/teams/users',
        component: () => import('./views/teams/TeamEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            altNavSubMenuActive:'/teams/index',
        },
        children: [
            {
                path: '',
                name: 'TeamUsers',
                component: () => import('./views/teams/tables/TeamUsers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/history',
                name: 'TeamHistory',
                component: () => import('./views/teams/tables/TeamHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
                 
            },  {
                path: '/(uk/|ru/)?/teams/history/detail',
                name: 'TeamHistoryDetail',
                component: () => import('./views/teams/tables/TeamHistoryDetail'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/balance',
                name: 'TeamHistoryBalance',
                component: () => import('./views/teams/tables/TeamHistoryBalance'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            },  {
                path: '/(uk/|ru/)?/teams/payRequest',
                name: 'TeamPayRequest',
                component: () => import('./views/teams/tables/TeamPayRequest'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            },  {
                path: '/(uk/|ru/)?/teams/candidates',
                name: 'TeamCandidates',
                component: () => import('./views/teams/tables/TeamCandidates'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            },  {
                path: '/(uk/|ru/)?/teams/summary',
                name: 'TeamSummary',
                component: () => import('./views/teams/tables/TeamSummary'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/sms/index',
        name: 'SMSlist',
        component: () => import('./views/sms/SMSlist'),
        //// adopt done
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-mobile',
            title: 'Список СМС'
        }
    }, {
        path: '/(uk/|ru/)?/dumps/statistic-dumps',
        
        component: () => import('./views/dumps/index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Управление'
        },
        children: [
            {
                path: '',
                name: 'dumpsComplete',
                component: () => import('./views/dumps/tables/complete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Обработанные'
                },
                children: [
                    {
                        path: '',
                        name: 'completePhotocontrol',
                        component: () => import('./views/dumps/tables/completePhotocontrol'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Завершение регистрации'
                        },
                    },
                    {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/lead/complete',
                        name: 'dumpsCompleteList',
                        component: () => import('./views/dumps/tables/completeTable'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Завершение регистрации'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/lead',
                        name: 'dumpscompleteLead',
                        component: () => import('./views/dumps/tables/completeLead'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Возврат неактивных'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/repeat',
                        name: 'dumpscompleteRepeat',
                        component: () => import('./views/dumps/tables/completeRepeat'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Обзвон'
                        },
                    },
                ]
            },
            {
                path: '/(uk/|ru/)?/dumps/statistic-dumps/statistic',
                name: 'dumpsUnComplete',
                component: () => import('./views/dumps/tables/UnComplete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Статистика'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/dumps/statistic-dumps/statistic/operator',
        name: 'Operator',
        component: () => import('./views/dumps/tables/Operator'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Оператор'
        },
    }, {
        path: '',
        name: 'DumpsCalling',
        component: () => import('./views/dumps/calling'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Обзвон'
        },
        children: [
            {
                path: '/(uk/|ru/)?/call-dumps/calling/registered',
                name: 'DumpsNew',
                component: () => import('./views/dumps/tables/DumpsNew'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Новые'
                },
            }, 
            {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/work',
                name: 'DumpsInWork',
                component: () => import('./views/dumps/tables/DumpsInWork'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'В работе'
                },
            }, 
            {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/finished',
                name: 'DumpsFinished',
                component: () => import('./views/dumps/tables/DumpsFinished'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Завершенные'
                },
            }, 
            {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/registered',
                name: 'DumpsRegistered',
                component: () => import('./views/dumps/tables/DumpsRegistered'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Зарегистрированные'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling',
                name: 'DumpsPhotocontrol',
                component: () => import('./views/dumps/tables/DumpsPhotocontrol'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Фотоконтроль'
                },
            }, 
            {
                path: '/(uk/|ru/)?/call-dumps/calling/complete',
                name: 'CallingComplete',
                component: () => import('./views/dumps/tables/CallingComplete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Завершение регистрации'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/repeat',
                name: 'CallingRepeat',
                component: () => import('./views/dumps/tables/CallingRepeat'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Возврат неактивных'
                },
            },  {
                path: '/(uk/|ru/)?/call-dumps/calling/lead',
                name: 'CallingLead',
                component: () => import('./views/dumps/tables/CallingLead'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Подумают'
                },
            },
        ]

    }, {
        path: '/(uk/|ru/)?/dumps/calling/driver',
        name: 'DumpsDriver',
        component: () => import('./views/dumps/Driver'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Водитель'
        },
    }, {
        path: '/(uk/|ru/)?/self-emloyment/status-history',
        name: 'selfemploymentIndex',
        component: () => import('./views/selfemployment/index'),
        query: true,
        meta: {
            requiresAuth: true,
           // activeSideIcon:'#icon-dumps',
            title: 'История статусов'
        },
    }, {
        path: '/(uk/|ru/)?/self-emloyment/without-employment',
        name: 'selfemploymentDrivers',
        component: () => import('./views/selfemployment/drivers'),
        query: true,
        meta: {
            requiresAuth: true,
          //  activeSideIcon:'#icon-dumps',
            title: 'Без самозанятости'
        },
    }, {
        path: '/(uk/|ru/)?/self-emloyment/option',
        name: 'selfemploymentReference',
        component: () => import('./views/selfemployment/reference'),
        query: true,
        meta: {
            requiresAuth: true,
          //  activeSideIcon:'#icon-dumps',
            title: 'Самозанятость Настройки'
        },
    }, {
        path: '/(uk/|ru/)?/car/index',
        name: 'ListAuto',
        component: () => import('./views/rentauto/ListAuto.vue'),
        query: true,
        meta: {
            requiresAuth: true,
          //  activeSideIcon:'#icon-dumps',
            title: 'Список авто'
        },
    }, {
        path: '/(uk/|ru/)?/car/all-car',
        name: 'ListAllCar',
        component: () => import('./views/rentauto/ListAllCar.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-arrow-right',
            title: 'Список всех авто'
        },
    }, {
        path: '/(uk/|ru/)?/car/create',
        // adopt done
        name: 'createAuto',
        component: () => import('./views/rentauto/modules/create.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Список авто',
            altNavSubMenuActive:'/car/index',
        },
    }, {
        path: '/(uk/|ru/)?/car/view',
        name: 'viewAuto',
        component: () => import('./views/rentauto/modules/view.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Просмотр авто',
            altNavSubMenuActive:'/car/all-car',
        },
    }, {
        path: '/(uk/|ru/)?/request/index',
        name: 'ListRent',
        component: () => import('./views/rentauto/ListRent.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Аренда Авто',
        },
    }, {
        path: '',
        name: 'task-pool',
        component: () => import('./views/financial/TaskPool.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-financial',
            altNavSubMenuActive:'/financial/task-pool',
        },
        children: [ {
            path: '/(uk/|ru/)?/financial/task-pool',
            name: 'Task',
            component: () => import('./views/financial/Task'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-financial',
                title: 'Финансовый мониторинг'
            },
        }, {
            path: '/(uk/|ru/)?/financial/history',
            name: 'TaskHistory',
            component: () => import('./views/financial/History'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-financial',
                title: 'Финансовый мониторинг',
            },
        },]
    }, {
        path: '',
        name: 'ie_main',
        component: () => import('./views/individual-entrepreneurship/list.vue'),
        // adopt done
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Список ИП',
        },
        children: [{
            path: '/(uk/|ru/)?/individual-entrepreneurship/list',
            name: 'ie_List',
            component: () => import('./views/individual-entrepreneurship/tables/list.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }, {
            path: '/(uk/|ru/)?/individual-entrepreneurship/app',
            name: 'ie_app',
            component: () => import('./views/individual-entrepreneurship/tables/app.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }]
    }, {
        path: '/(uk/|ru/)?/individual-entrepreneurship/create',
        name: 'ie_create',
        component: () => import('./views/individual-entrepreneurship/create.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Создание нового ИП',
        },
    }, {
        path: '',
        name: 'ie_edit_form',
        component: () => import('./views/individual-entrepreneurship/Edit.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Создание нового ИП',
        },
        children: [ {
            path: '/(uk/|ru/)?/individual-entrepreneurship/edit',
            name: 'ie_edit',
            component: () => import('./views/individual-entrepreneurship/tab_edit.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }, {
            path: '/(uk/|ru/)?/individual-entrepreneurship/edit/driver',
            name: 'ie_subDriver',
            component: () => import('./views/individual-entrepreneurship/driver.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }]
    }, {
        path: '',
        name: 'nca',
        component: () => import('./views/NCALayer/index.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            title: 'NACLayer',
        },
        children: [{
            path: '/(uk/|ru/)?/ie/docs',
            name: 'ie_docs',
            component: () => import('./views/NCALayer/tables/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            }, 
        },{
            path: '/(uk/|ru/)?/ie/docs/invoice',
            name: 'ie_docs-invoice_month',
            component: () => import('./views/NCALayer/tables/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
                type: 'invoice_month'
            }, 
        },{
            path: '/(uk/|ru/)?/ie/docs/ya',
            name: 'ie_docs-ya_docs',
            component: () => import('./views/NCALayer/tables/ya_docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Документы от Яндекс',
            }, 
        }]
    }, {
        path: '',
        component: () => import('./views/refferall/idnex.vue'),
        meta: {
            requiresAuth: true,
            altNavSubMenuActive:'/promotions/referrals-list',
        }, 
        children: [{
            path: '/(uk/|ru/)?/promotions/referrals-list',
            name: 'refferallActive',
            component: () => import('./views/refferall/tables/active.vue'),
            meta: {
                requiresAuth: true,
                title: 'Реферельная программа',
                activeSideIcon:'#icon-discount',
            },
        }, {
            path: '/(uk/|ru/)?/promotions/referrals-list/archive',
            name: 'refferallArchive',
            component: () => import('./views/refferall/tables/archive.vue'),
            meta: {
                requiresAuth: true,
                title: 'Реферельная программа: архив',
                activeSideIcon:'#icon-discount',
            },
        }]
    }, {
        path: '/(uk/|ru/)?/wolt/aggregators',
        name: 'woltAggregators',
        component: () => import('./views/wolt/aggregators/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегаторы',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/create',
        name: 'WoltAggregatorsCreate',
        component: () => import('./views/wolt/aggregators/create'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегатор создание',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/edit',
        name: 'WoltAggregatorsEdit',
        component: () => import('./views/wolt/aggregators/edit'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегатор редактирование',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/couriers',
        name: 'Woltcouriers',
        component: () => import('./views/wolt/couriers/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt курьеры',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/transactions',
        name: 'Wolttransactions',
        component: () => import('./views/wolt/transactions'),
        meta: {
            requiresAuth: true,
            title: 'Wolt транзакции',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/work-rules',
        name: 'WoltworkRules',
        component: () => import('./views/wolt/workRules/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Условия Работ',
        }, 
    }, {
        path: '/(uk/|ru/)?/wolt/work-rules/create',
        name: 'WoltworkRulesCreate',
        component: () => import('./views/wolt/workRules/create'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Условия Работ',
        }, 
    }, {
        //path: '',
        path: '/(uk/|ru/)?/wolt/earnings',
        name: 'WoltEarnings',
        component: () => import('./views/wolt/earnings'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Зароботок',
        }, 
        children: [{
            path: '/(uk/|ru/)?/wolt/earnings',
            name: 'WoltEarningsCurrent',
            component: () => import('./views/wolt/earnings/table/current'),
            meta: {
                requiresAuth: true,
                title: 'Wolt Зароботок',
                activeSideIcon:'#icon-bars',
            },
        }, {
            path: '/(uk/|ru/)?/wolt/archive',
            name: 'WoltEarningsArchive',
            component: () => import('./views/wolt/earnings/table/archive'),
            meta: {
                requiresAuth: true,
                title: 'Wolt Архив',
                activeSideIcon:'#icon-bars',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/wolt/metrics',
        name: 'Woltmetrics',
        component: () => import('./views/wolt/metrics/index'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Меетрики',
            activeSideIcon:'#icon-bars',
        }, 
    }, {
        path: '',
        name: 'couriersAgreements',
        component: () => import('./views/wolt/couriersAgreements/index'),
        meta: {
            requiresAuth: true,
            
            activeSideIcon:'#icon-bars',
        },
        children: [{
            path: '/(uk/|ru/)?/wolt/couriers-agreements',
            name: 'wolt_docs',
            component: () => import('./views/wolt/couriersAgreements/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-bars',
                title: 'Wolt Документы',
                type: 'draft'
            },
        }, {
            path: '/(uk/|ru/)?/wolt/couriers-agreements/signed',
            name: 'wolt_docs-signed',
            component: () => import('./views/wolt/couriersAgreements/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-bars',
                title: 'Wolt Документы подписанные',
                type: 'sign'
            },
        }]
    }, {
        path: '',
        component: () => import('./views/wolt/signUp/index.vue'),
        meta: {
            requiresAuth: true,
            altNavSubMenuActive:'/promotions/referrals-list',
        }, 
        children: [{
            path: '/(uk/|ru/)?/wolt/sign-up',
            name: 'WoltSignUpNew',
            component: () => import('./views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация новые',
                type: 'new',
            },
        }, {
            path: '/(uk/|ru/)?/wolt/sign-up/onboard',
            name: 'WoltSignUpOnboard',
            component: () => import('./views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация на расмотрении',
                type: 'onboard',
            },
        },{
            path: '/(uk/|ru/)?/wolt/sign-up/finished',
            name: 'WoltSignUpFinished',
            component: () => import('./views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация законченные',
                type: 'finished',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/wolt/sign-up/edit',
        name: 'WoltSignUpEdit',
        component: () => import('./views/wolt/signUp/forms/edit.vue'),
        meta: {
            requiresAuth: true,
            title: 'Обработка кандидата',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '',
        name: 'heldBonusesIndex',
        component: () => import('./views/wolt/held-bonuses/index'),
        meta: {
            requiresAuth: true,
        }, 
        children: [{
            path: '/(uk/|ru/)?/wolt/held-bonuses',
            name: 'heldBonusesHolded',
            component: () => import('./views/wolt/held-bonuses/tabs/held'),
            meta: {
                requiresAuth: true,
                title: 'Удержанные бонусы: История',
                activeSideIcon:'#icon-bars',
            }
        }, {
            path: '/(uk/|ru/)?/wolt/held-bonuses/history',
            name: 'heldBonusesHistory',
            component: () => import('./views/wolt/held-bonuses/tabs/history'),
            meta: {
                requiresAuth: true,
                title: 'Удержанные бонусы: История',
                activeSideIcon:'#icon-bars',
            }
        }],
    }, {
        path: '/(uk/|ru/)?/wolt/orders',
        name: 'WoltOrders',
        component: () => import('./views/wolt/orders'),
        meta: {
            requiresAuth: true,
            title: 'Заказы',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/on-board',
        name: 'WoltSignUpOnBoard',
        component: () => import('./views/wolt/onBoard/index.vue'),
        meta: {
            requiresAuth: true,
            title: 'Онбоард',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/cars/list',
        name: 'IronParksCarsList',
        component: () => import('./views/iron-parks/cars/list'),
        meta: {
            requiresAuth: true,
            title: 'Авто железного парка',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-active',
        name: 'IronParksCarsRentList',
        component: () => import('./views/iron-parks/cars/rentList'),
        meta: {
            requiresAuth: true,
            title: 'Аренда',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-active/:type',
        name: 'IronParksCarsTypeRentList',
        component: () => import('./views/iron-parks/cars/typeTables'),
        meta: {
            requiresAuth: true,
            title: 'Детализация',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-form/:driver_id/:park_id/:car_id',
        name: 'IronParksCarsRentForm',
        component: () => import('./views/iron-parks/cars/rentForm'),
        meta: {
            requiresAuth: true,
            title: 'Арендное авто',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/cars/assign',
        name: 'IronParksCarsLAssign',
        component: () => import('./views/iron-parks/cars/assign/index.vue'),
        meta: {
            requiresAuth: true,
            title: 'Назначение железного парка',
        }, 
    }, {
        
        path: '',
        name: 'IronParksCarsIndex',
        component: () => import('./views/iron-parks/cars/edit/index'),
        meta: {
            requiresAuth: true,
            title: 'Редактирование',
            altNavSubMenuActive:'/iron-parks/cars/list',
        }, 
        children: [{
            path: '/(uk/|ru/)?/iron-parks/cars/edit',
            name: 'IronParksCarsEdit',
            component: () => import('./views/iron-parks/cars/edit/edit'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Основной',
            },
        },{
            path: '/(uk/|ru/)?/iron-parks/cars/edit/mileage',
            name: 'IronParksCarsMileage',
            component: () => import('./views/iron-parks/cars/edit/mileage'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Пробег',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/docs',
            name: 'IronParksCarsDocs',
            component: () => import('./views/iron-parks/cars/edit/docs'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Пробег',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/history',
            name: 'IronParksCarsHistory',
            component: () => import('./views/iron-parks/cars/edit/history'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: История',
            },
        },{
            path: '/(uk/|ru/)?/iron-parks/cars/edit/payments',
            name: 'IronParksCarsPayments',
            component: () => import('./views/iron-parks/cars/edit/payments'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Оплаты',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/orders',
            name: 'IronParksCarsOrders',
            component: () => import('./views/iron-parks/cars/edit/orders'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Поездки',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/driver',
            name: 'IronParksCarsDriverDriver',
            component: () => import('./views/iron-parks/cars/edit/driver'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Поездки',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/iron-parks/drivers',
        name: 'IronParksDriversList',
        component: () => import('./views/iron-parks/drivers/list'),
        meta: {
            requiresAuth: true,
            title: 'Водители ',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/drivers/editr',
        name: 'IronParksDriversEdit',
        component: () => import('./views/iron-parks/drivers/editr'),
        meta: {
            requiresAuth: true,
            title: 'Водитель железного парка',
            altNavSubMenuActive:'/iron-parks/drivers',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/summary-cars',
        name: 'IronParksCarsList',
        component: () => import('./views/iron-parks/summaryCars'),
        meta: {
            requiresAuth: true,
            title: 'Сводная статистика по авто',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/history-assignment',
        name: 'IronParksAssignmentHistory',
        component: () => import('./views/iron-parks/historyAssignment'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/orders-history',
        name: 'IronParksOrdersHistory',
        component: () => import('./views/iron-parks/ordersHistory'),
        meta: {
            requiresAuth: true,
            title: 'История поездок',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/payments-history',
        name: 'IronParksPaymentsHistory',
        component: () => import('./views/iron-parks/paymentsHistory'),
        meta: {
            requiresAuth: true,
            title: 'Сводная статистика по авто',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/list',
        name: 'IronParksPaymentsHistory',
        component: () => import('./views/iron-parks/list'),
        meta: {
            requiresAuth: true,
            title: 'Арендные авто',
        }, 
    },  {
        path: '',
        component: () => import('./views/iron-parks/paymentsList'),
        meta: {
            requiresAuth: true,
            title: 'Список оплат',
        }, 
        children: [{
            path: '/(uk/|ru/)?/iron-parks/payments-list',
            name: 'IronParksPaymentsListCurrent',
            component: () => import('./views/iron-parks/paymentsList/current'),
            meta: {
                requiresAuth: true,
                title: 'Список оплат: текущие',
            }, 
        }, {
            path: '/(uk/|ru/)?/iron-parks/payments-list/history',
            name: 'IronParksPaymentsListHistory',
            component: () => import('./views/iron-parks/paymentsList/history'),
            meta: {
                requiresAuth: true,
                title: 'Список оплат: история',
            }, 
        }]
    }, {
        path: '/(uk/|ru/)?/iron-parks/assign-history',
        name: 'IronParksAssignHistory',
        component: () => import('./views/iron-parks/assignHistory'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        }, 
    }, {
        path: '/(uk/|ru/)?/iron-parks/fines',
        name: 'IronParksFines',
        component: () => import('./views/iron-parks/fines'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        }, 
    }, { 
        path: '/(uk/|ru/)?/iron-parks/mutual-settlement',
        name: 'mutualSettlement',
        component: () => import('./views/iron-parks/mutualSettlement/list'),
        meta: {
            activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Взаиморасчёты',
        }, 
    }, { 
        path: '/(uk/|ru/)?/iron-parks/mutual-settlement/detail',
        name: 'mutualSettlementDetail',
        component: () => import('./views/iron-parks/mutualSettlement/detail'),
        meta: {
            activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Взаиморасчёты детализация',
        }, 
    }, { 
        path: '/(uk/|ru/)?/candidates/AI',
        name: 'reportsCandidatesAiNew',
        component: () => import('./views/drivers/default/CandidatesAI'),
        meta: {
            //activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Кандидаты от ИИ: Новые',
        },

    }, { 
        path: '/(uk/|ru/)?/candidates/AI/finished',
        name: 'reportsCandidatesAiNewFinished',
        component: () => import('./views/drivers/default/CandidatesAIFinished'),
        meta: {
            //activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Кандидаты от ИИ: Завершенные',
        },

    }, { 
        path: '/(uk/|ru/)?/drivers/AI',
        name: 'mutualSettlementDetail',
        component: () => import('./views/drivers/default/DriversAI'),
        meta: {
            //activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Водители от ИИ',
        }, 
    }, { 
        path: '/(uk/|ru/)?/chats/AI',
        name: 'mutualSettlementDetail',
        component: () => import('./views/drivers/default/ChatsAI'),
        meta: {
            //activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Водители от ИИ',
        }, 
    }
]

export default new Router({
    mode: 'history',
    base: '/',
    routes
}) 
